/**
 * Kontak Tab — Email and Phone side by side.
 */

import * as React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Mail, Phone, CheckCircle2, XCircle } from "lucide-react";
import type { User } from "@/services/authService";
import { EmailTab } from "./EmailTab";
import { PhoneTab } from "./PhoneTab";

interface SurelTeleponTabProps {
  user: User;
  isOwnProfile: boolean;
  allowEditPhone: boolean;
  onPhoneSaved?: () => void | Promise<void>;
}

function EmailReadOnlyCard({ user }: { user: User }) {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <Mail className="h-5 w-5 text-muted-foreground" />
          <CardTitle>Email</CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        <div className="border border-border rounded-lg overflow-hidden">
          <div className="p-4 border-b border-border">
            <div className="text-xs text-muted-foreground mb-1">Status</div>
            <div className="flex items-center gap-2">
              {user.isUpdatedEmail ? (
                <Badge variant="outline" className="gap-1 text-green-700 border-green-200 dark:text-green-300 dark:border-green-800">
                  <CheckCircle2 className="h-3 w-3" />
                  Terverifikasi
                </Badge>
              ) : (
                <Badge variant="outline" className="gap-1 text-destructive border-destructive/30">
                  <XCircle className="h-3 w-3" />
                  Belum terverifikasi
                </Badge>
              )}
            </div>
          </div>
          <div className="p-4">
            <div className="text-xs text-muted-foreground mb-1">Alamat Email</div>
            <div className="text-sm font-medium text-foreground">{user.email || "-"}</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export function SurelTeleponTab({
  user,
  isOwnProfile,
  allowEditPhone,
  onPhoneSaved,
}: SurelTeleponTabProps) {
  return (
    <div className="grid gap-6 lg:grid-cols-2 lg:items-start">
      <div className="min-w-0">
        {isOwnProfile ? <EmailTab user={user} /> : <EmailReadOnlyCard user={user} />}
      </div>
      <div className="min-w-0">
        <PhoneTab user={user} allowEdit={allowEditPhone} onPhoneSaved={onPhoneSaved} />
      </div>
    </div>
  );
}
